<template>
  <div
    class="preview-image-viewer preview-viewer"
    ref="imgWrap"
  >
    <img
      v-if="url"
      ref="imgEl"
      :class="['img-item', renderLimit && 'limit']"
      :src="url"
      :style="{height: imgHeight + 'px'}"
      @load="handleImgLoaded"
    />
    <van-loading v-else/>
    <!-- <div v-if="canSwipeRight" class="left-arrow"></div>
    <div v-if="canSwipeLeft" class="right-arrow"></div> -->
  </div>
</template>
<script>
import AlloyFinger from 'alloyfinger'
import 'alloyfinger/asset/transform'
import To from '@/utils/to'
import Press from '../mixins/press'

export default {
  name: 'ImageViewer',
  mixins: [ Press ],
  props: {
    previewInfo: Object,
    item: Object,
    renderLimit: Boolean,
    imgTouchable: Boolean
  },
  data () {
    return {
      url: null,
      imgRotate: 0,
      isDestoryed: false,
      changedWH: false,
      imgHeight: '',
      canSwipeLeft: false,
      canSwipeRight: false,
      deltaSwipe: 0,
      originX: null,
      originY: null
    }
  },
  created () {
    if (this.previewInfo && this.previewInfo.download_url) {
      this.getInitDeg()
      this.setImageData(this.previewInfo.download_url)
    }
  },
  mounted () {
    this.handlePress(this.$refs.imgWrap, (left, top) => {
      // 向上滑收起
      this.$emit('pressmove', top)
    })
  },
  beforeDestroy () {
    this.isDestoryed = true
  },
  methods: {
    setImageData (download_url) {
      this.url = null
      this.loadImage(download_url).then((imageData) => {
        if (this.isDestoryed) return
        if (imageData) {
          let {url, width, height} = imageData
          if (this.changedWH) { // 旋转了奇数个90度
            let temp = width
            width = height
            height = temp
          }
          const {offsetWidth, offsetHeight} = this.$refs.imgWrap
          // add image margin
          if (offsetWidth < width || offsetHeight < (height + 20)) {
            this.imgHeight = Math.round(height / Math.max(width / offsetWidth, height / offsetHeight))
            if (this.changedWH) {
              this.imgHeight = Math.round((width / height) * this.imgHeight)
            }
          }
          this.url = url
        }
      })
    },
    getInitDeg () {
      if (this.previewInfo.exif_rotation && this.previewInfo.exif_rotation > 1) {
        let rotate = 0
        switch (this.previewInfo.exif_rotation) {
          case 6:
            rotate += 90
            break
          case 8:
            rotate -= 90
            break
          case 3:
            rotate += 180
            break
        }
        this.imgRotate = rotate
        this.changedWH = (this.imgRotate / 90) % 2 === 1
      }
    },
    initFinger () {
      const el = this.$refs.imgEl
      const elWrapper = this.$refs.imgWrap
      const self = this
      window.Transform(el)
      el.rotateZ += this.imgRotate
      function ease (x) {
        return Math.sqrt(1 - Math.pow(x - 1, 2))
      }
      let initScale = 1
      this.finger = new AlloyFinger(el, {
        multipointStart: function () {
          To.stopAll()
          initScale = el.scaleX
        },
        rotate: function (evt) {
          el.rotateZ += evt.angle
        },
        pinch: function (evt) {
          let { offsetWidth: wrapperWidth, offsetHeight: wrapperHeight } = elWrapper
          const windowHeight = document.querySelector('#app').offsetHeight
          const headerHeight = windowHeight - wrapperHeight
          el.scaleX = el.scaleY = initScale * evt.zoom
          const { top, right, bottom, left } = el.getBoundingClientRect()

          // 保持图片在窗口内
          if (left > 0 && right >= wrapperWidth) { // 左侧在窗口内，右侧在窗口外，保持左侧到边
            el.translateX -= left
          }

          if (right < wrapperWidth && left <= 0) { // 右侧在窗口内，左侧在窗口外，保持右侧到边
            el.translateX += (wrapperWidth - right)
          }

          if (top > headerHeight && bottom >= windowHeight) { // 上侧在窗口内，下侧在窗口外，保持上侧到边
            el.translateY -= (top - headerHeight)
          }

          if (bottom < windowHeight && top <= headerHeight) { // 下侧在窗口内，上侧在窗口外，保持下侧到边
            el.translateY += (windowHeight - bottom)
          }
        },
        multipointEnd: function () {
          To.stopAll()
          /* eslint-disable no-new */
          if (el.scaleX < 0.8) {
            new To(el, 'scaleX', 0.8, 500, ease)
            new To(el, 'scaleY', 0.8, 500, ease)
          }
          if (el.scaleX > 5) {
            new To(el, 'scaleX', 3, 500, ease)
            new To(el, 'scaleY', 3, 500, ease)
          }
          let rotation = el.rotateZ % 360

          if (rotation < 0)rotation = 360 + rotation
          el.rotateZ = rotation

          if (rotation > 0 && rotation < 45) {
            new To(el, 'rotateZ', 0, 500, ease)
          } else if (rotation >= 315) {
            new To(el, 'rotateZ', 360, 500, ease)
          } else if (rotation >= 45 && rotation < 135) {
            new To(el, 'rotateZ', 90, 500, ease)
          } else if (rotation >= 135 && rotation < 225) {
            new To(el, 'rotateZ', 180, 500, ease)
          } else if (rotation >= 225 && rotation < 315) {
            new To(el, 'rotateZ', 270, 500, ease)
          }
        },
        pressMove: function (evt) {
          let { deltaX, deltaY } = evt
          const { top, right, bottom, left, width, height } = el.getBoundingClientRect()
          let { offsetWidth: wrapperWidth, offsetHeight: wrapperHeight } = elWrapper
          const { right: wrapperRight, left: wrapperLeft } = elWrapper.getBoundingClientRect()
          const headerHeight = document.querySelector('#app').offsetHeight - wrapperHeight

          let wrapperDeltaX = 0

          // 图片能移动到居中位置
          const marginX = Math.max(0, (wrapperWidth - width) / 2)
          const marginY = Math.max(0, (wrapperHeight - height) / 2)

          let canSwipeRight = false
          let canSwipeLeft = false

          if (deltaX > 0) { // 向右滑动
            if (left - wrapperLeft >= marginX) { // 图片处于居中位置的右侧 此时可以向左滑
              wrapperDeltaX = deltaX
              canSwipeLeft = true
            } else if (deltaX + (left - wrapperLeft) > marginX) { // 图片将要移动到居中位置的右边（图片左侧的坐标加上将要移动的距离大于居中时图片左侧的坐标）， 则最多移动到居中位置
              wrapperDeltaX = deltaX - (marginX - (left - wrapperLeft))
              self.changeTranslateX(el, marginX - (left - wrapperLeft))
            } else {
              wrapperDeltaX = 0
              self.changeTranslateX(el, deltaX)
            }
          } else if (deltaX < 0) { // 向左滑动
            if (wrapperRight - right >= marginX) { // 图片处于居中位置的左侧 此时可以向右滑
              wrapperDeltaX = deltaX
              canSwipeRight = true
            } else if (deltaX + (wrapperRight - right) > marginX) { // 图片右边的坐标减去将要移动的距离 小于 图片居中时右边的坐标 则最多移动到居中位置
              wrapperDeltaX = marginX - (wrapperRight - right - deltaX)
              self.changeTranslateX(el, wrapperRight - right - marginX)
            } else {
              wrapperDeltaX = 0
              self.changeTranslateX(el, deltaX)
            }
          }

          if (deltaY > 0) { // 向下滑动
            if (deltaY + top > headerHeight + marginY) {
              el.translateY += headerHeight + marginY - top
            } else {
              el.translateY += deltaY
            }
          } else if (deltaY < 0) { // 向上滑动
            if (deltaY + bottom < headerHeight + wrapperHeight - marginY) {
              el.translateY += headerHeight + wrapperHeight - marginY - bottom
            } else {
              el.translateY += deltaY
            }
          }

          self.hanldeSwipe(wrapperDeltaX)

          self.canSwipeLeft = canSwipeLeft
          self.canSwipeRight = canSwipeRight

          evt.preventDefault()
        },
        doubleTap: function (evt) {
          To.stopAll()
          if (el.scaleX !== 1) {
            new To(el, 'scaleX', 1, 500, ease)
            new To(el, 'scaleY', 1, 500, ease)
            new To(el, 'translateX', 0, 500, ease)
            new To(el, 'translateY', 0, 500, ease)
          } else {
            const box = el.getBoundingClientRect()

            // 点击位置的坐标
            const x = evt.changedTouches[0].pageX
            const y = evt.changedTouches[0].pageY

            // 默认放大两倍
            new To(el, 'scaleX', 2, 500, ease)
            new To(el, 'scaleY', 2, 500, ease)

            // 将点击位置移动到屏幕原来的位置，移动的距离为：图片中心（box.left + box.width / 2， box.top + box.height）距离点击位置的距离
            new To(el, 'translateX', box.left + box.width / 2 - x, 500, ease)
            new To(el, 'translateY', box.top + box.height / 2 - y, 500, ease)
            /* eslint-enable no-new */
          }
        }
      })
    },
    changeTranslateX (el, deltaX) {
      if (this.imgTouchable) {
        el.translateX += deltaX
      }
    },
    hanldeSwipe (deltaX) {
      this.$emit('image-swipe', deltaX)
    },
    loadImage (url) {
      const img = document.createElement('img')
      let promiseResolve
      const promise = new Promise((resolve) => { promiseResolve = resolve })
      img.setAttribute('style', 'display: none')
      img.onload = () => {
        img.setAttribute('style', 'display:block;position:absolute;left:-99999px;top:-99999px;')
        const { width, height } = img.getBoundingClientRect()
        promiseResolve({
          width,
          height,
          url
        })
        img.parentNode.removeChild(img)
      }

      img.onerror = () => {
        promiseResolve(false)
      }

      document.body.appendChild(img)
      img.src = url

      return promise
    },
    handleImgLoaded () {
      this.initFinger()
    }
  }
}
</script>
<style lang="postcss">
.preview-image-viewer {
  display: flex;
  align-items: center;
  justify-content: center;

  & .van-loading {
    margin: 0 auto
  }

  & .left-arrow,
  & .right-arrow {
    position: absolute;
    top: 50%;
    margin-top: -5px;
    width: 10px;
    height: 10px;
    background-color: #55f;
  }

  & .left-arrow {
    left: 0;
  }

  & .right-arrow {
    right: 0;
  }
}
</style>
